export const INTERVIEW_STATIC_TEXTS = [
  "Please select your preferred language.",
  "Select answer above",
  "Reconnecting to your interview...",
  "The screener is currently experiencing issues. Please return later to complete your screening.",
  "Hang in there, still working on a response...",
  "Waiting for next question...",
  "Preparing voice recorder...",
  "Enter message",
  "Record instead",
  "Skip",
  "Skip question",
  "Back to previous question",
  "Loading previous question...",
  "Powered by Upwage",
  "Terms",
  "Privacy Policy",
  "Start the interview to begin the conversation",
  "You're all set — your interview has been submitted.",
  "Interview ended unexpectedly. Please contact support if you need assistance.",
  // AS-1866 — post-interview candidate feedback
  "How was your interview?",
  "Is there anything you want to share about your experience?",
  "Your feedback",
  "Submit feedback",
  "Feedback submitted",
  "Yes",
  "No",
  "Select as many as you want",
  "Select one",
  "Done selecting",
  "Done Selecting",
  "File Uploaded",
  "Selected file to upload",
  "Voice response submitted",
  "File size exceeds the 10 MB limit",
  "Unsupported file type. Allowed types:",
  "Upload failed",
  "There was a problem uploading your file. Please try again.",
  "Remove file",
  "Done uploading",
  "Select file to upload",
  "Max size 10 MB",
  "Max size 10MB",
  "Max size 10mb",
  "Region or code not found",
  "Enter digits only",
  'Enter numbers only (e.g. "2.5")',
  "Send Message",
  "Phone number does not appear valid for the selected region",
  "Unable to start recording. Please check your microphone permissions.",
  "There was a problem recording your audio",
  "Mic access denied",
  "Allow microphone access",
  "Stop recording",
  "Start recording",
  "Type instead",
  "Please try again, or use the Skip button if the problem persists.",
  "Please try again.",
  "Editing this answer is not available yet",
  "There was a problem uploading your response.",
  "There was a problem sending your answer.",
  "Unable to play recording due to browser restrictions",
  "Playback of this type of media is not supported by your browser",
  "There was a problem playing your recording",
  "Submit voice message",
  "Delete",
  "Play",
  "Stop",
  "Switch to light mode",
  "Switch to dark mode",
  "No problem. You can always come back to this page when you're ready to get started.",
  "Progress Saved",
  "Session options",
  "A resume link has been sent to your email. You can return to complete your interview later.",
  "Error",
  "Failed to save progress. Please try again.",
  "Save progress",
  "Restart interview",
  "Save Your Progress",
  "Enter your email address and we will send you a link to resume your interview later.",
  "Email",
  "Save & Send Link",
  "Start over?",
  "Your previous answers will be cleared.",
  "Cancel",
  "Start over",
  // AS-1564 — interview progress bar label. The {current} / {total} tokens
  // are placeholders the FE replaces at render time after translation; the
  // back-end translation cache treats them as opaque strings.
  "Question {current} of {total}",
];

const AS_1565_LOCAL_INTRO =
  'Before we begin, this interview is powered by a partner AI tool to make interviewing more accessible for you. Your responses will be used to evaluate your fit for this role. By continuing, you agree to our <a href="https://www.upwage.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms</a> and <a href="https://www.upwage.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.\n\nThis local interview is for AS-1565 manual testing. Please use fake candidate information only.';

const SPANISH_STATIC_TRANSLATIONS: Record<string, string> = {
  "Please select your preferred language.": "Selecciona tu idioma preferido.",
  "Select answer above": "Selecciona una respuesta arriba",
  "Reconnecting to your interview...": "Reconectando con tu entrevista...",
  "The screener is currently experiencing issues. Please return later to complete your screening.":
    "El evaluador esta teniendo problemas. Vuelve mas tarde para completar tu evaluacion.",
  "Hang in there, still working on a response...":
    "Un momento, aun estamos preparando una respuesta...",
  "Waiting for next question...": "Esperando la siguiente pregunta...",
  "Preparing voice recorder...": "Preparando la grabadora de voz...",
  "Enter message": "Escribe un mensaje",
  "Record instead": "Grabar en su lugar",
  Skip: "Omitir",
  "Skip question": "Omitir pregunta",
  "Back to previous question": "Volver a la pregunta anterior",
  "Loading previous question...": "Cargando la pregunta anterior...",
  "Powered by Upwage": "Con tecnologia de Upwage",
  Terms: "Terminos",
  "Privacy Policy": "Politica de privacidad",
  "Start the interview to begin the conversation":
    "Inicia la entrevista para comenzar la conversacion",
  "You're all set — your interview has been submitted.":
    "Todo listo; tu entrevista ha sido enviada.",
  "Interview ended unexpectedly. Please contact support if you need assistance.":
    "La entrevista termino inesperadamente. Contacta a soporte si necesitas ayuda.",
  "How was your interview?": "Como fue tu entrevista?",
  "Is there anything you want to share about your experience?":
    "Hay algo que quieras compartir sobre tu experiencia?",
  "Your feedback": "Tus comentarios",
  "Submit feedback": "Enviar comentarios",
  "Feedback submitted": "Comentarios enviados",
  Yes: "Si",
  No: "No",
  "Select as many as you want": "Selecciona todas las opciones que quieras",
  "Select one": "Selecciona una opcion",
  "Done selecting": "Listo",
  "Done Selecting": "Listo",
  "File Uploaded": "Archivo subido",
  "Selected file to upload": "Archivo seleccionado para subir",
  "Voice response submitted": "Respuesta de voz enviada",
  "File size exceeds the 10 MB limit": "El archivo supera el limite de 10 MB",
  "Unsupported file type. Allowed types:":
    "Tipo de archivo no compatible. Tipos permitidos:",
  "Upload failed": "Error al subir el archivo",
  "There was a problem uploading your file. Please try again.":
    "Hubo un problema al subir tu archivo. Intentalo de nuevo.",
  "Remove file": "Eliminar archivo",
  "Done uploading": "Terminar carga",
  "Select file to upload": "Seleccionar archivo para subir",
  "Max size 10 MB": "Tamano maximo 10 MB",
  "Max size 10MB": "Tamano maximo 10 MB",
  "Max size 10mb": "Tamano maximo 10 MB",
  "Region or code not found": "Region o codigo no encontrado",
  "Enter digits only": "Ingresa solo digitos",
  'Enter numbers only (e.g. "2.5")': 'Ingresa solo numeros (p. ej. "2.5")',
  "Send Message": "Enviar mensaje",
  "Phone number does not appear valid for the selected region":
    "El numero de telefono no parece valido para la region seleccionada",
  "Unable to start recording. Please check your microphone permissions.":
    "No se pudo iniciar la grabacion. Revisa los permisos del microfono.",
  "There was a problem recording your audio":
    "Hubo un problema al grabar tu audio",
  "Mic access denied": "Acceso al microfono denegado",
  "Allow microphone access": "Permitir acceso al microfono",
  "Stop recording": "Detener grabacion",
  "Start recording": "Iniciar grabacion",
  "Type instead": "Escribir en su lugar",
  "Please try again, or use the Skip button if the problem persists.":
    "Intentalo de nuevo o usa el boton Omitir si el problema continua.",
  "Please try again.": "Intentalo de nuevo.",
  "Editing this answer is not available yet":
    "Editar esta respuesta aun no esta disponible",
  "There was a problem uploading your response.":
    "Hubo un problema al subir tu respuesta.",
  "There was a problem sending your answer.":
    "Hubo un problema al enviar tu respuesta.",
  "Unable to play recording due to browser restrictions":
    "No se puede reproducir la grabacion por restricciones del navegador",
  "Playback of this type of media is not supported by your browser":
    "Tu navegador no admite la reproduccion de este tipo de medio",
  "There was a problem playing your recording":
    "Hubo un problema al reproducir tu grabacion",
  "Submit voice message": "Enviar mensaje de voz",
  Delete: "Eliminar",
  Play: "Reproducir",
  Stop: "Detener",
  "Switch to light mode": "Cambiar a modo claro",
  "Switch to dark mode": "Cambiar a modo oscuro",
  "No problem. You can always come back to this page when you're ready to get started.":
    "Sin problema. Siempre puedes volver a esta pagina cuando estes listo para comenzar.",
  "Progress Saved": "Progreso guardado",
  "Session options": "Opciones de sesion",
  "A resume link has been sent to your email. You can return to complete your interview later.":
    "Se envio un enlace para reanudar a tu correo. Puedes volver para completar tu entrevista mas tarde.",
  Error: "Error",
  "Failed to save progress. Please try again.":
    "No se pudo guardar el progreso. Intentalo de nuevo.",
  "Save progress": "Guardar progreso",
  "Restart interview": "Reiniciar entrevista",
  "Save Your Progress": "Guarda tu progreso",
  "Enter your email address and we will send you a link to resume your interview later.":
    "Ingresa tu correo electronico y te enviaremos un enlace para reanudar tu entrevista mas tarde.",
  Email: "Correo electronico",
  "Save & Send Link": "Guardar y enviar enlace",
  "Start over?": "Empezar de nuevo?",
  "Your previous answers will be cleared.":
    "Tus respuestas anteriores se borraran.",
  Cancel: "Cancelar",
  "Start over": "Empezar de nuevo",
  "Question {current} of {total}": "Pregunta {current} de {total}",
  "What is your full name?": "Cual es tu nombre completo?",
  "What is your email?": "Cual es tu correo electronico?",
  "Thank you. What is your email?": "Gracias. Cual es tu correo electronico?",
  "What is your phone number?": "Cual es tu numero de telefono?",
  "Thank you. What is your phone number?":
    "Gracias. Cual es tu numero de telefono?",
  "Please skip this file-upload question, then confirm the Back button is hidden on the next prompt.":
    "Omite esta pregunta de carga de archivo y luego confirma que el boton Volver esta oculto en la siguiente pregunta.",
  "After skipping the file upload, the Back button should be hidden here. Type a short answer to continue.":
    "Despues de omitir la carga de archivo, el boton Volver debe estar oculto aqui. Escribe una respuesta corta para continuar.",
  "Voice test: record or skip this question. The next written prompt should not allow returning to this voice answer.":
    "Prueba de voz: graba u omite esta pregunta. La siguiente pregunta escrita no debe permitir volver a esta respuesta de voz.",
  "Final written test question: after you answer this, the interview should complete and Back should be unavailable.":
    "Pregunta escrita final de prueba: despues de responderla, la entrevista debe completarse y Volver no debe estar disponible.",
  "Thanks for completing this AS-1565 manual verification interview. We have everything we need.":
    "Gracias por completar esta entrevista de verificacion manual de AS-1565. Tenemos todo lo que necesitamos.",
  [AS_1565_LOCAL_INTRO]:
    'Antes de comenzar, esta entrevista funciona con una herramienta de IA asociada para hacer las entrevistas mas accesibles para ti. Tus respuestas se usaran para evaluar si eres una buena opcion para este puesto. Al continuar, aceptas nuestros <a href="https://www.upwage.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terminos</a> y <a href="https://www.upwage.com/privacy-policy" target="_blank" rel="noopener noreferrer">Politica de privacidad</a>.\n\nEsta entrevista local es para pruebas manuales de AS-1565. Usa solo informacion falsa del candidato.',
};

export function getStaticTranslationFallback(
  languageCode: string | null,
  englishText: string,
): string | undefined {
  if (!languageCode?.toLowerCase().startsWith("es")) {
    return undefined;
  }

  return SPANISH_STATIC_TRANSLATIONS[englishText];
}
